export default __webpack_public_path__ + "static/media/setion01_bg_m.3c1d33cc.png";